import { Icon } from '@busybusy/webapp-react-ui';
import { GPSIcon, LockOutlineIcon } from 'assets/icons';
import UpgradePromptView from 'containers/settings/subscriptions/UpgradePromptView/UpgradePromptView';
import { t } from 'i18next';
import { ClassName } from 'types/ClassName';
import './ImportantAccountChangesView.scss';

export interface IImportantAccountChangesViewProps {
  className?: ClassName;
  isOpen: boolean;
  onClose: () => void;
}

const ImportantAccountChangesView = (props: IImportantAccountChangesViewProps) => {
  const { className, isOpen, onClose } = props;

  return (
    <UpgradePromptView
      className={className}
      title={t('Important Account Changes')}
      description={t(
        'Due to increased costs surrounding GPS and data storage, the following changes are being applied to your plan.'
      )}
      offerDescription={t(
        "We apologize for the inconvenience. To help, we'd like to offer you two exclusive plan options not available to all customers."
      )}
      enableCloseGuard
      viewType="account_changed"
      isOpen={isOpen}
      onClose={onClose}
    >
      <div className="account-change-rows px-6 pb-6">
        <div className="account-change-row">
          <Icon svg={LockOutlineIcon} size={32} />
          <div className="account-change-text">
            <div className="account-change-title">{t('Limited Job Costing Items')}</div>
            <div className="account-change-subtitle">
              {t(
                'You must have fewer than 5 active projects, cost codes, and equipment items before creating a new one.'
              )}
            </div>
          </div>
        </div>
        <div className="account-change-row">
          <Icon svg={GPSIcon} size={32} />
          <div className="account-change-text">
            <div className="account-change-title">{t('Limited GPS Features')}</div>
            <div className="account-change-subtitle">
              {t('Users can no longer view GPS locations for other employees.')}
            </div>
          </div>
        </div>
      </div>
    </UpgradePromptView>
  );
};

export default ImportantAccountChangesView;
